import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  /**
   * Check if the user can activate the route
   * 
   * @param next ActivatedRouteSnapshot
   * @param state RouterStateSnapshot
   */
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    try {
      const isAuthenticated = await this.authService.isAuthenticated();

      if (isAuthenticated) {
        return true;
      }

      // If user is not authenticated, redirect to login
      return this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });

    } catch (error) {
      console.error('Error in AuthGuard:', error);
      // Redirect to login if an error occurs
      return this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
    }
  }
}
